// Office business documents. They belong to no client, which is why they are their own
// file rather than part of clients.js.
//
// Pure data — no imports, ever. errors.js reads he.leads.needContact at module scope,
// so a part reaching back for it would hand that read a half-built object. See he.js.
const documents = {
  // The office filing cabinet: business paperwork that belongs to no client.
  documents: {
    title: 'מסמכי העסק',
    add: 'העלאת מסמך',
    edit: 'עריכת מסמך',
    name: 'שם המסמך',
    namePlaceholder: 'למשל: הסכם שכירות משרד',
    category: 'קטגוריה',
    allCategories: 'כל הקטגוריות',
    // Short, because it sits inline beside the picker rather than on its own line.
    categoryAdd: '＋ קטגוריה חדשה',
    categoryAddPrompt: 'שם הקטגוריה',
    date: 'תאריך המסמך',
    notes: 'הערות',
    file: 'קובץ',
    fileChoose: 'בחירת קובץ',
    uploading: 'מעלה...',
    uploadedBy: 'הועלה על ידי',
    uploadedAt: 'הועלה בתאריך',
    // The archive is a separate view — an archived document is out of sight by
    // definition, so it is never mixed into the live list.
    showArchive: 'הצגת הארכיון',
    showLive: 'חזרה למסמכים הפעילים',
    archiveTitle: 'ארכיון מסמכים',
    archivedBy: 'הועבר לארכיון על ידי',
    restore: 'שחזור מהארכיון',
    // The two-choice dialog. It always names the document, because a signed
    // agreement is not an expense line — one of these options cannot be undone.
    remove: 'הסרה',
    removeTitle: 'הסרת מסמך',
    removeQuestion: 'מה לעשות עם המסמך?',
    archiveAction: 'הוצאה מהתצוגה',
    archiveHint: 'המסמך יוסר מהרשימה ויישמר בארכיון, וניתן לשחזר אותו.',
    deleteAction: 'מחיקה לצמיתות',
    deleteHint: 'הרשומה והקובץ יימחקו לצמיתות, ללא אפשרות שחזור.',
  },
};

export default documents;
